const ROUTE = {
  ADD_SCREEN_CYCLE: '/clients/:clientId/contracts/:contractId/screens/:screenId/cycles/add',
  ADD_CYCLE: '/clients/:clientId/contracts/:contractId/cycles/add',
  ADD_CYCLE_BY_LOCATION: '/clients/:clientId/cycles/add',
  AUTH_COMING_SOON: '/auth/coming-soon',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_SIGN_IN: '/sign-in',
  AUTH_CONFIRM_PASSWORD_RESET: '/auth/confirm-password-reset',
  CALIBRATION_CERTIFICATES: '/controllers/:id/calibration-certificates',
  CALIBRATION_CERTIFICATE_CREATE: '/controllers/:id/calibration-certificates/create',
  CALIBRATION_CERTIFICATE_EDIT: '/controllers/:id/calibration-certificates/:certificateId/edit',
  CONTRACTS: '/contracts',
  CONTROLLER: '/controllers/:id',
  CONTROLLERS: '/controllers',
  CONTROLLER_CHANNELS: '/controllers/:id/channels',
  CONTROLLER_CHANNEL_FAULTS: '/controllers/:id/channel-faults',
  CONTROLLER_CHANNELS_NAMES: '/controllers/:id/channelnames',
  CONTROLLER_CHANNELS_COLORS: '/controllers/:id/channelcolors',
  CREATE_CONTRACT: '/contracts/create',
  CREATE_LOCATION: '/clients/create',
  CREATE_MEMBERS: '/members/create',
  CREATE_RECIPE: '/recipes/create',
  CREATE_RECIPE_STEPS: '/recipes/:id/steps/create',
  CREATE_SCREEN: '/clients/:clientId/contracts/:contractId/screens/create',
  CREATE_SCREEN_BY_LOCATION: '/clients/:clientId/screens/create',
  EDIT_SCREEN: '/clients/:clientId/contracts/:contractId/screens/:screenId/edit',
  EDIT_SCREEN_BY_OVERVIEW_PAGE: '/clients/:clientId/screens/:screenId/edit',
  CYCLE_WITHOUT_SCREEN: '/clients/:clientId/contracts/:contractId/cycles/:id',
  CYCLE: '/clients/:clientId/contracts/:contractId/screens/:screenId/cycles/:id',
  CYCLES: '/cycles',
  CYCLE_REPORT_WITHOUT_SCREEN: '/clients/:clientId/contracts/:contractId/cycles/:id/report',
  CYCLE_REPORT: '/clients/:clientId/contracts/:contractId/screens/:screenId/cycles/:id/report',
  CYCLE_REPORTS: '/clients/:clientId/contracts/:contractId/screens/:screenId/cycles/:id/reports/:cycleReportId',
  CYCLE_REPORTS_WITHOUT_SCREEN: '/clients/:clientId/contracts/:contractId/cycles/:id/reports/:cycleReportId',
  EDIT_CONTRACT: '/contracts/:id/edit',
  EDIT_CONTROLLER: '/controllers/:id/edit',
  EDIT_CONTROLLER_CHANNEL: '/controllers/:id/channels/:channel_number/edit',
  EDIT_CONTROLLER_SYSTEM_FAULTS: '/controllers/:id/sysfaults',
  EDIT_CONTROLLER_FAULT_CONTROL: '/controllers/:id/faultcontrol',
  EDIT_CONTROLLER_POWER_SHARE: '/controllers/:id/powershare',
  EDIT_CONTROLLER_SETTINGS: '/controllers/:id/settings',
  EDIT_CYCLE: '/clients/:clientId/contracts/:contractId/screens/:screenId/cycles/:id/edit',
  EDIT_CYCLE_WITHOUT_SCREEN: '/clients/:clientId/contracts/:contractId/cycles/:id/edit',
  EDIT_LOCATION: '/clients/:id/edit',
  EDIT_MEMBER: '/members/:id/edit',
  EDIT_RECIPE: '/recipes/:id/edit',
  EDIT_PRE_HEAT_RECIPE: '/pre-heat-recipes/:id/edit',
  EDIT_RECIPE_STEPS: '/recipes/:id/steps/:step_id/edit',
  FORBIDDEN_RESOURCE: '/forbidden-resource',
  HOME: '/',
  LOCATIONS: '/clients',
  LOCATION_CONTRACTS: '/clients/:clientId/contracts',
  LOCATION_CONTRACTS_OVERVIEW: '/clients/:clientId/contracts/overview',
  LOCATION_CONTRACT_SCREENS: '/clients/:clientId/contracts/:contractId',
  MEMBERS: '/members',
  NOT_FOUND: '/*',
  ORGANIZATIONS: '/organizations',
  PROFILE: '/profile',
  RECIPES: '/recipes',
  RECIPE_STEPS: '/recipes/:id/steps',
  SCREEN_CYCLES: '/clients/:clientId/contracts/:contractId/screens/:screenId',
};

export default ROUTE;
